export const MATCHING_GIFTS_ENDPOINT = "/microsite/api/sections/matching_gifts_sections";

export const MATCHING_GIFTS_API = "/api/v2/matching_gifts";
export const DONATIONS_V2_API = "/api/v2/donations";
export const DONATIONS_EVERYDAY_FORM_V2_API = "/api/v2/donations/everyday_form";
export const CAMPAIGNS_V2_API = "/api/v2/campaigns";
export const CAMPAIGNS_LIST_API = "/microsite/api/campaigns/donation_list";
export const CAMPAIGNS_STATUS_API = "/microsite/api/campaigns/campaign_status";
export const CREATE_ABANDON_FORM_API = "/abandon_form/create";
export const SRPEEDLY_CHALLENGE_SUCCESS_API =
  "/api/v2/donations/spreedly_challenge_success";
